// src/components/job-engine/CronInput.tsx
import React, { useMemo } from "react";
import { TextField, Text, Stack } from "@fluentui/react";
import { parseExpression } from "cron-parser";

interface Props {
  value: string;
  onChange: (next: string) => void;
  label?: string;
}

const CronInput: React.FC<Props> = ({ value, onChange, label = "Cron" }) => {
  const { nextFires, error } = useMemo(() => {
    if (!value) return { nextFires: [], error: null as string | null };
    try {
      const it = parseExpression(value);
      const list: string[] = [];
      for (let i = 0; i < 5; i++) list.push(it.next().toISOString());
      return { nextFires: list, error: null };
    } catch (e) {
      return { nextFires: [], error: "Invalid cron expression" };
    }
  }, [value]);

  return (
    <Stack tokens={{ childrenGap: 6 }}>
      <TextField
        label={label}
        value={value}
        onChange={(_, v) => onChange(v ?? "")}
        errorMessage={error ?? undefined}
      />
      {error && (
        <Text variant="small" styles={{ root: { color: "#a4262c" } }} data-testid="cron-error">
          {error}
        </Text>
      )}
      {nextFires.length > 0 && (
        <Stack tokens={{ childrenGap: 2 }}>
          <Text variant="small" styles={{ root: { fontWeight: 600 } }}>Next 5 fires (UTC)</Text>
          <ul data-testid="cron-preview" style={{ margin: 0, paddingLeft: 20 }}>
            {nextFires.map((f) => (
              <li key={f}><Text variant="small">{f}</Text></li>
            ))}
          </ul>
        </Stack>
      )}
    </Stack>
  );
};

export default CronInput;
